import React, { forwardRef } from 'react'

import { RowProps } from './row.types'
import { useStyle } from './row.styles'

export const Row = forwardRef<HTMLDivElement, RowProps>(
  (
    {
      alignItems,
      justifyContent,
      className,
      fullHeight,
      fullWidth,
      children,
      ...props
    },
    ref
  ) => {
    const classes = useStyle({
      alignItems,
      fullHeight,
      fullWidth,
      justifyContent
    })

    return (
      <div {...props} className={`${className || ''} ${classes.row}`} ref={ref}>
        {children}
      </div>
    )
  }
)
